import React from 'react';
import ankleBraceletIcon from 'components/TagTypesIcon/ankle-bracelet-50';
import army62Icon from 'components/TagTypesIcon/army-62';
import army67Icon from 'components/TagTypesIcon/army-67';
import army67Icon2 from 'components/TagTypesIcon/army-67-(1)';
import businessDocumentationIcon from 'components/TagTypesIcon/business-documentation-50';
import child50Icon from 'components/TagTypesIcon/child-50';
import child50Icon2 from 'components/TagTypesIcon/child-50-(1)';
import cityHallIcon from 'components/TagTypesIcon/city-hall-50';
import courthouseIcon from 'components/TagTypesIcon/courthouse-50';
import crime50Icon from 'components/TagTypesIcon/crime-50';
import crosswalkIcon from 'components/TagTypesIcon/crosswalk-50';
import deafIcon from 'components/TagTypesIcon/deaf-50';
import disclaimerIcon from 'components/TagTypesIcon/disclaimer-50';
import fistIcon from 'components/TagTypesIcon/fist-50';
import gangIcon from 'components/TagTypesIcon/gang-50';
import grandfatherIcon from 'components/TagTypesIcon/grandfather-50';
import highRiskIcon from 'components/TagTypesIcon/high-risk-50';
import lawCourtIcon from 'components/TagTypesIcon/law-court-50';
import masterSergeantIcon from 'components/TagTypesIcon/master-sergeant-msg-50';
import medicalIcon from 'components/TagTypesIcon/medical-50';
import meetingIcon from 'components/TagTypesIcon/meeting-50';
import MentalHealthIcon from 'components/TagTypesIcon/mental-health';
import NamesIcon from 'components/TagTypesIcon/names-50';
import PoliceIcon from 'components/TagTypesIcon/police-50';
import ScheduleIcon from 'components/TagTypesIcon/schedule-50';
import SexOffenderIcon from 'components/TagTypesIcon/sex-offender-50';
import SkullCrossboneIcon from 'components/TagTypesIcon/skull-crossbones-50';
import SoldierManIcon from 'components/TagTypesIcon/soldier-man-50';
import PaperIcon from 'components/TagTypesIcon/paper-50';
import PassFailIcon from 'components/TagTypesIcon/pass-fail-50';
import PoliceBadgeIcon from 'components/TagTypesIcon/police-badge-50';
import PoliticianIcon from 'components/TagTypesIcon/politician-50';
import SheriffIcon from 'components/TagTypesIcon/sheriff-50';

function EmptyTagIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="currentColor"
      {...props}>
      <path d="M15 23h20v4H15z" />
    </svg>
  );
}

const PERSON_TAG_ICONS = {
  0: EmptyTagIcon,
  1: ankleBraceletIcon,
  2: army62Icon,
  3: army67Icon,
  4: army67Icon2,
  5: businessDocumentationIcon,
  6: child50Icon,
  7: child50Icon2,
  8: cityHallIcon,
  9: courthouseIcon,
  10: crime50Icon,
  11: crosswalkIcon,
  12: deafIcon,
  13: disclaimerIcon,
  14: fistIcon,
  15: gangIcon,
  16: grandfatherIcon,
  17: highRiskIcon,
  18: lawCourtIcon,
  19: masterSergeantIcon,
  20: medicalIcon,
  21: meetingIcon,
  22: MentalHealthIcon,
  23: NamesIcon,
  24: PoliceIcon,
  25: ScheduleIcon,
  26: SexOffenderIcon,
  27: SkullCrossboneIcon,
  28: SoldierManIcon,
  29: PaperIcon,
  30: PassFailIcon,
  31: PoliceBadgeIcon,
  32: PoliticianIcon,
  33: SheriffIcon,
};

export const resolveIcon = (iconIndex) => PERSON_TAG_ICONS[iconIndex] || EmptyTagIcon;

export const resolveDescription = (options, code) =>
  options?.find((option) => option.Code === code)?.Description || code || '';
